import { render, staticRenderFns } from "./FixedPhraseMenu.vue?vue&type=template&id=022c152b&scoped=true&"
import script from "./FixedPhraseMenu.vue?vue&type=script&lang=ts&"
export * from "./FixedPhraseMenu.vue?vue&type=script&lang=ts&"
import style0 from "./FixedPhraseMenu.vue?vue&type=style&index=0&id=022c152b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022c152b",
  null
  
)

export default component.exports